import { useState } from "react";
import { Alert, Button, styled } from "@mui/material";
import { useGetSubscriptionStatusQuery, useCreatePortalSessionMutation } from "Services/subscription";

const BannerButton = styled(Button)({
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
});

export default function PastDueBanner() {
  const { data } = useGetSubscriptionStatusQuery(undefined, { pollingInterval: 60000 });
  const [createPortalSession, { isLoading }] = useCreatePortalSessionMutation();
  const [error, setError] = useState<string | null>(null);

  if (data?.payment_status !== "past_due") return null;

  const handleUpdatePayment = async () => {
    setError(null);
    try {
      const { url } = await createPortalSession().unwrap();
      window.location.href = url;
    } catch (err: any) {
      setError(err?.data?.message || err?.message || "Failed to open billing portal.");
    }
  };

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <BannerButton color="inherit" size="small" onClick={handleUpdatePayment} disabled={isLoading}>
          {isLoading ? "Loading..." : "Update Payment Method"}
        </BannerButton>
      }
    >
      {error ?? "Your last payment failed. Please update your payment method to avoid losing access."}
    </Alert>
  );
}